import { useNavigate } from 'react-router-dom';
import Card from '../../../components/base/Card';
import Button from '../../../components/base/Button';

interface MedicalService {
  id: string;
  title: string;
  description: string;
  price: string;
  duration: string;
  image: string;
  category: string;
}

const medicalServices: MedicalService[] = [
  {
    id: '1',
    title: 'استشارة طبية عامة',
    description: 'فحص شامل مع طبيب مختص',
    price: '150 ريال',
    duration: '30 دقيقة',
    image: 'https://public.readdy.ai/ai/img_res/64292e56b489f4320e2008adc56cb65f.jpg',
    category: 'استشارات'
  },
  {
    id: '2',
    title: 'تحاليل مختبرية شاملة',
    description: 'فحوصات دم ومختبرية متكاملة',
    price: '200 ريال',
    duration: '15 دقيقة',
    image: 'https://readdy.ai/api/search-image?query=Medical%20laboratory%20testing%20equipment%2C%20blood%20samples%2C%20modern%20lab%20setting%2C%20clean%20professional%20environment%2C%20medical%20technology%2C%20microscope%2C%20test%20tubes%2C%20bright%20lighting%2C%20healthcare%20photography&width=300&height=200&seq=medical2&orientation=landscape',
    category: 'تحاليل'
  },
  {
    id: '3',
    title: 'أشعة تشخيصية',
    description: 'أشعة سينية وتصوير طبي',
    price: '300 ريال',
    duration: '20 دقيقة',
    image: 'https://readdy.ai/api/search-image?query=Medical%20X-ray%20imaging%20equipment%2C%20radiology%20department%2C%20modern%20medical%20technology%2C%20clean%20hospital%20environment%2C%20diagnostic%20imaging%2C%20professional%20healthcare%20setting%2C%20bright%20medical%20lighting&width=300&height=200&seq=medical3&orientation=landscape',
    category: 'أشعة'
  }
];

export default function MedicalServices() {
  const navigate = useNavigate();

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-bold text-[#333333]">الخدمات الطبية</h2>
        <button 
          onClick={() => navigate('/services')}
          className="text-[#007AFF] text-sm font-medium"
        >
          عرض الكل
        </button>
      </div>
      
      <div className="space-y-4">
        {medicalServices.map((service) => (
          <Card key={service.id} padding="md">
            <div className="flex gap-4">
              <img
                src={service.image}
                alt={service.title}
                className="w-20 h-20 rounded-xl object-cover object-top"
              />
              <div className="flex-1">
                <div className="flex items-start justify-between mb-2">
                  <div>
                    <h3 className="font-bold text-[#333333] text-sm mb-1">{service.title}</h3>
                    <p className="text-[#7A7A7A] text-xs mb-2">{service.description}</p>
                  </div>
                  <span className="bg-[#34C759]/10 text-[#34C759] px-2 py-1 rounded-lg text-xs font-medium">
                    {service.category}
                  </span>
                </div>
                
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4 text-xs text-[#7A7A7A]">
                    <span className="flex items-center gap-1">
                      <i className="ri-money-dollar-circle-line"></i>
                      {service.price}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {service.duration}
                    </span>
                  </div>
                  <Button 
                    size="sm" 
                    className="text-xs px-4 py-2"
                    onClick={() => navigate('/booking')}
                  >
                    احجز الآن
                  </Button>
                </div>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
